import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d7mymnraud: FaireBrandEntity = {
  token: "b_d7mymnraud",
  type: "brand",
  name: "Big Green Organic Food",
  avatarUrl:
    "https://cdn.faire.com/fastly/f5ba5621861dcbefb59415600b10387f85f7fe82272cded18eac2925e60e4a97.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a36512ee97c8b813e9530cd860669f7e99cf6ecee1d332b83847c5b03f850d95.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f5ba5621861dcbefb59415600b10387f85f7fe82272cded18eac2925e60e4a97.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a36512ee97c8b813e9530cd860669f7e99cf6ecee1d332b83847c5b03f850d95.jpeg",
  location: "City of Industry, CA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    "Eating healthy should not be a privilege. At Big Green Organic Foods, we are purveyors of fine organic, gluten-free, grains, pasta, flour, herbs, and berries. We hope all our efforts will bring people organic and natural foods for health and wellness.\n\nBig Green Organic Food works with farms untouched by chemicals and pesticides to bring you non-GMO, certified organic, gluten-free foods created and packaged in facilities that have never processed wheat, rye, or barley products.\n\n\nBig Green Organic Food is committed to preserving the organic nature and integrity of the brand. We believe the real healthy organic food should only have three or fewer ingredients, therefore our organic products are mostly made with a single ingredient. Before launching a new product, we are heavily involved in the development process by personally tasting and experimenting with the texture. We bring the values, heritage, and traditions of the East and introduce them to the modern and fast-paced Western countries.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:30.380Z",
    importedBy: "entity-db-cli",
  },
};
